<!--
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-09-13 13:32:15
 * @LastEditors: 李文敬
 * @LastEditTime: 2021-09-18 09:12:19
-->
<template>
  <div id="article">
    <div
      :style="{
        height: `${phoneSearchHeight}px`
      }"
    />

    <div style="padding: 3%; padding-top: 0;">
      <img
        src="@/assets/images/13441631515546.jpg"
        draggable="false"
        style="width: 100%;"
      >

      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 10px 30px;
          background: #fff;
          font-size: 20px;
          color: #D2B559
        "
        class="litter-display-block litter-font-class litter-padding-class"
      >
        <div style="text-align: left;">不用硫磺防腐，采用冷链储藏的精品中药创立者。</div>
        <div style="text-align: right;">客服热线：400-0755-911</div>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          padding: 10px 30px;
          background: #D2B559;
          font-size: 20px;
          color: #fff;
          margin-top: 3%;
        "
        class="litter-font-class litter-padding-class"
      >
        <div
          style="height: 20px; width: 10px; border-radius: 5px; background: #fff; margin-right: 10px;"
          class="litter-height-class"
        />
        <div>收费模式</div>
      </div>

      <div style="padding: 3%; background: #fff;">
        <div
          style="padding: 2%; border-radius: 5px; background: #F2E19F; color: #77502B; font-size: 18px; line-height: 20px;"
          class="litter-font-class"
        >
          1、合作收费：我司与合作企业官方网站上发布他们的产品信息进行推广和宣传，收取费用：2000元/月。
        </div>
        <div
          style="padding: 2%; border-radius: 5px; background: #F2E19F; color: #77502B; font-size: 18px; line-height: 20px; margin-top: 3%;"
          class="litter-font-class"
        >
          2、广告收费：我司还提供网站推广服务，在官方网站上发布广告，每次收费1200元。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      contentOneInfoBottom: null,
      contentTwoInfoBottom: null,
      litterHeight: 150,
      topItemImg: '',
      topItemFont: {},
      bottomItemImg: '',
      bottomItemFont: [],
      nineGridData: [],
      phoneSearchHeight: 0
    }
  },
  methods: {
    setHeight() {
      this.$parent.getHeightList()
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/article/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/article/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/article/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/article/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/article/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/chargeMode.vue